module.exports = __webpack_public_path__ + "img/蒙版组3002@2x.e9383927.png";